import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from 'material-ui';

import styles from './styles.scss';

export default class ClientListFilter extends React.Component {
  static propTypes = {
    numClients: PropTypes.number,
    numFiltered: PropTypes.number,
    updateFilter: PropTypes.func.isRequired,
    filter: PropTypes.string,
  }

  static defaultProps = {
    numClients: 0,
    numFiltered: 0,
    filter: '',
  }

  render() {
    const { numClients, numFiltered, updateFilter, filter } = this.props;

    return (<div className={styles.listFilter}>
      <div className={styles.tripListFilters}>
        <div className={styles.filter}>
          <TextField
            floatingLabelText='Filter clients by name'
            onChange={updateFilter}
            value={filter}
          />
        </div>
      </div>
      <div className={styles.infoLine}>
        {numFiltered} (of {numClients}) clients displayed
      </div>
    </div>);
  }
}



// WEBPACK FOOTER //
// /src/components/Clients/ClientListFilters.js